<!--  -->
<template>
  <div>
   <div>
     <div class="mobileSina" style="margin-top: 69px;" id="app">
      <header class="login_header">
        <h1>
          <i class="logo_ico" style="display: inline-block; width: 6.96875em; height: 7.96875em; text-indent: -9999em; background: url(/static/images/ZGY_sx_n.png) no-repeat; background-size: 6.96875em;">
          北京创远时代培训系统
          </i>
        </h1>
        <h2 class="prompt" id="loginSource"></h2>
      </header>
      <section id="beforeLogin" class="login_main">
        <form method="post">
  
          <ul class="info">
            <li id="loginNamePanel" class="account">
              <input type="text" v-model="loginUser.identificationcard" autocapitalize="off" autocorrect="off" placeholder="证件号码" />
            </li>
            <li id="loginPasswordPanel">
              <input type="password" v-model="loginUser.password"   placeholder="密码" />
            </li>
            <li id="loginPasswordPanel">
              <input type="text" v-model="loginUser.yzcode" style="    width: 63%;"  placeholder="验证码" />
               <img
                  :src="loginUser.yzmsrc"
                  @click="getImgVerify()"
                  style="width: 37%"
                  alt="看不清?请点击刷新"
                  title="看不清?请点击刷新"
                  class="validate-code"
                  />
            </li>
          </ul>
          <a @click="submitForm()" class="btn_login" id="loginAction">登录</a>
          <router-link to="/signup" class="signup">线上报名<i class="el-icon-arrow-right"></i></router-link>
        </form>
      </section>
    </div>
    <center>
      <div style="font-size: 10px;background-color:#c3c3c3"><a href="http://beian.miit.gov.cn/" style="color:#000" target="_blank">京ICP备2022002443号-1</a></div>
    </center>
   </div>
   </div>
  </template>
  <script>
  import jwt_decode from "jwt-decode";
  import global from "../components/PublicComs/Common.vue";
  import { Message } from "element-ui";
  export default {
    data() {
      return {
        loginUser: {
          password: "",
          identificationcard: "",
          yzcode: "",
          yzmsrc: "",
        },
        global,
        webConfig: {},
        checked: false,
      };
    },
  
    components: {},
  
    computed: {},
  
    mounted() {
      this.$axios.get("/api/webConfigs").then((res) => {
        if (res.data && res.data.data.length > 0) {
          this.webConfig = res.data.data[0];
        }
      });
      this.getImgVerify();
      this.getCookie();
      window.addEventListener("keydown", this.keyDown);
    },
    beforeCreate() {
      document.querySelector("body").setAttribute("style", "height: 100%;");
    },
    beforeDestroy() {
      document.body.removeAttribute("style");
      window.removeEventListener("keydown", this.keyDown, false);
    },
    created() {},
    methods: {
      submitForm() {
        if (!this.loginUser.password) {
          Message.error("密码不能为空！");
          return;
        } else if (!this.loginUser.identificationcard) {
          Message.error("身份证号码不能为空！");
          return;
        }
        this.$axios.post("/api/auth/login", this.loginUser).then((res) => {
          // 登录成功
          const self = this;
          //判断复选框是否被勾选 勾选则调用配置cookie方法
          if (self.checked == true) {
            console.log("checked == true");
            //传入账号名，密码，和保存天数3个参数
            self.setCookie(
              this.loginUser.password,
              this.loginUser.identificationcard,
              30
            );
          } else {
            console.log("清空Cookie");
            //清空Cookie
            self.clearCookie();
            self.setCookie(this.loginUser.name, "", 30);
          }
          const { token } = res.data;
          localStorage.setItem("eleTokenCustCysd001", token);
  
          // 解析token
          const decode = jwt_decode(token);
          // 存储数据
          this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
          this.$store.dispatch("setUser", decode);
           //获取购买的课程
            let arrhasCourse = [];
            for (var i = 0; i <res.data.data.needexaminee.length; i++)
            {
              arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
            }
            this.$root.hasCourse =arrhasCourse;
          this.$root.ischeckface = res.data.data.ischeckface;
          this.$root.onlymycourse = res.data.data.onlymycourse;
          this.$root.buytype = res.data.data.buytype;
          if( res.data.data.onlymycourse)
              localStorage.setItem("onlymycourseCySd", "1");
          else
            localStorage.setItem("onlymycourseCySd", "0");
          localStorage.setItem("hasCourseCySd", arrhasCourse.join(","));
          // 页面跳转
          this.$router.push("/");
        });
      },
      getImgVerify() {
        this.loginUser.yzmsrc =
          `${this.global.remoteIp}/api/auth/imgverify` + "?" + Math.random();
      },
      keyDown(e) {
        //如果是按回车则执行登录方法
        if (e.keyCode == 13) {
          this.submitForm();
        }
      },
      //设置cookie
      setCookie(c_name, c_id, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        //字符串拼接cookie
        window.document.cookie =
          "stuName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        if (c_id) {
          window.document.cookie =
            "stuId" + "=" + c_id + ";path=/;expires=" + exdate.toGMTString();
        }
      },
      //读取cookie
      getCookie: function() {
        if (document.cookie.length > 0) {
          var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("="); //再次切割
            //判断查找相对应的值
            if (arr2[0] == "stuName") {
              this.loginUser.password = arr2[1]; //保存到保存数据的地方
            } else if (arr2[0] == "stuId") {
              this.loginUser.identificationcard = arr2[1];
              this.checked = true;
            }
          }
        }
      },
      isEmpty(value) {
        return (
          value === undefined ||
          value === null ||
          (typeof value === "object" && Object.keys(value).length === 0) ||
          (typeof value === "string" && value.trim().length === 0)
        );
      },
      //清除cookie
      clearCookie: function() {
        this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  @import "@/assets/css/loginphonestyle.scss";
  .signup{
    float: right;
      text-decoration: underline;
      font-size: 15px;
      margin-top: 10px;
      color: #7c2ec0;
  }
  .mobileSina{
    height:700px !important;
  }
  </style>
  